import { format, enUS, ptBR } from '@/libs/date'
import type { DateFormatOptions, DateValue } from '../domain/date-format'
import type { UserPreferenceLocale, UserPreferenceTimeFormat } from '../domain/user-preferences'

const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/

// yyyy-MM-dd strings are parsed as local dates to avoid the UTC midnight shift
// that new Date('2026-06-03') would introduce.
const parseDateValue = (value: DateValue): Date | null => {
	if (!value) return null
	if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value

	const dateOnly = DATE_ONLY_PATTERN.exec(value)
	if (dateOnly) {
		const [, year, month, day] = dateOnly
		return new Date(Number(year), Number(month) - 1, Number(day))
	}

	const parsed = new Date(value)
	return Number.isNaN(parsed.getTime()) ? null : parsed
}

const locales = { en: enUS, "pt-BR": ptBR }

const timeToken = (timeFormat: UserPreferenceTimeFormat) => (timeFormat === 12 ? 'hh:mm a' : 'HH:mm')

const formatDate = (locale: UserPreferenceLocale, value: DateValue, options: DateFormatOptions): string | null => {
	const date = parseDateValue(value)
	if (!date) return typeof value === 'string' ? value : null

	const dateToken = options.dateFormat ?? 'dd/MM/yyyy'
	const pattern = options.kind === 'dateTime' ? `${dateToken} ${timeToken(options.timeFormat ?? 24)}` : dateToken

	return format(date, pattern, { locale: locales[locale] })
}

export { formatDate }
